export function xpraNonce(wssUri: string): string | undefined {
  return /\/xpra-([0-9a-f]{24})\/?$/.exec(wssUri)?.[1];
}

/** The app path that reopens the session behind <wssUri>. */
export function xpraPath(wssUri: string): string {
  const nonce = xpraNonce(wssUri);
  return nonce ? `/xpra/${nonce}` : '/xpra';
}

/**
 * Where an `xpra-disconnected` message should send us, or null to ignore it.
 *
 * The embedded client posts this from its own unload handler, which also fires
 * when we navigate away and the iframe goes with us. By then the browser is
 * already somewhere else, and following the message would yank the visitor off
 * the page they just chose -- so a disconnect only counts while we are still on
 * the session page.
 */
export function disconnectTarget(
  data: { redirect_url?: unknown },
  pathname: string,
  fallback: string,
): string | null {
  if (!pathname.startsWith('/xpra')) return null;
  return typeof data.redirect_url === 'string' && data.redirect_url
    ? data.redirect_url
    : fallback;
}
